<template>
  <section v-loading="listLoading" class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.entityType" clearable placeholder="内容类型" @change="list">
            <el-option label="帖子" value="topic" />
            <el-option label="文章" value="article" />
            <el-option label="评论" value="comment" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.entityId" placeholder="内容 ID" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.userId" placeholder="用户 ID" />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.auditAction" clearable placeholder="审核结论" @change="list">
            <el-option label="通过" value="allow" />
            <el-option label="转审核" value="review" />
            <el-option label="推广分流" value="promotion" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }" class="page-section">
      <el-table :data="results" border>
        <el-table-column prop="id" label="日志ID" width="90" />
        <el-table-column prop="entityType" label="内容类型" width="90" />
        <el-table-column prop="entityId" label="内容ID" width="90" />
        <el-table-column label="内容" min-width="260">
          <template slot-scope="{ row }">
            <div class="content-cell">
              <div class="content-title">
                <a v-if="row.detailUrl" :href="row.detailUrl | siteUrl" target="_blank">
                  {{ row.title || "-" }}
                </a>
                <span v-else>{{ row.title || "-" }}</span>
              </div>
              <div v-if="row.summary" class="content-summary">{{ row.summary }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="userId" label="用户ID" width="90" />
        <el-table-column prop="auditAction" label="结论" width="100" />
        <el-table-column label="来源" width="120">
          <template slot-scope="{ row }">
            {{ sourceLabel(row.auditSource) }}
          </template>
        </el-table-column>
        <el-table-column label="分流" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.isPromotion" type="warning" size="mini">推广</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="审核" width="90">
          <template slot-scope="{ row }">
            <el-tag v-if="row.shouldReview" type="danger" size="mini">待审</el-tag>
            <span v-else>通过</span>
          </template>
        </el-table-column>
        <el-table-column label="涉黄风险" width="100">
          <template slot-scope="{ row }">
            <el-tag v-if="row.isSexualRisk" type="danger" size="mini">涉黄</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="节点变更" width="140">
          <template slot-scope="{ row }">
            <span>{{ row.originalNodeId || "-" }} -> {{ row.finalNodeId || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="原因" min-width="220" />
        <el-table-column prop="matchedRules" label="命中规则" min-width="180" />
        <el-table-column label="时间" width="170">
          <template slot-scope="{ row }">
            {{ row.createTime | formatDate }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>
  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "ContentAuditLog",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
    };
  },
  mounted() {
    mainHeight(this);
    this.list();
  },
  methods: {
    async list() {
      this.listLoading = true;
      const params = Object.assign({}, this.filters, {
        entity_type: this.filters.entityType,
        entity_id: this.filters.entityId,
        audit_action: this.filters.auditAction,
        user_id: this.filters.userId,
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("/api/admin/content-audit-log/list", params);
        this.results = data.results;
        this.page = data.page;
      } finally {
        this.listLoading = false;
      }
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    sourceLabel(source) {
      if (source === "reviewing") {
        return "审核中";
      }
      if (source === "qwen") {
        return "千问";
      }
      if (source === "forbidden_word") {
        return "违禁词";
      }
      if (source === "local_rule") {
        return "本地规则";
      }
      if (source === "manual") {
        return "人工";
      }
      if (source === "system") {
        return "系统";
      }
      if (source === "disabled") {
        return "未启用";
      }
      return source || "-";
    },
  },
};
</script>

<style scoped lang="scss">
.page-section {
  overflow-y: auto;
}

.content-cell {
  .content-title {
    font-weight: 500;

    a {
      color: #409eff;
      text-decoration: none;
    }
  }

  .content-summary {
    margin-top: 4px;
    color: #6b7280;
    font-size: 12px;
    line-height: 1.5;
  }
}
</style>
